/**
 * Phase 41 (Plan 41-15 Task 2) — Sidebar v3 API client.
 *
 * Wraps the Phase 41 backend surface:
 *   GET /api/sidebar/customers — Customer to Project hierarchy for the
 *                                current user (PM OR ProjectAssignment).
 *
 * Response envelope is `{ data: SidebarCustomer[] }` per the standard
 * dataResponse helper in backend/src/api/schemas/common.ts. Every property
 * on the wire is enumerated explicitly in the backend schema (Pitfall 3
 * lock — see backend/src/api/schemas/sidebar.ts).
 *
 * MKS-196 — `billable` carries the project's real `projects.billable` value
 * (Phase 62 column); it was hard-coded `true` backend-side until then.
 */
import { apiGet } from './client';

export interface SidebarProject {
  id: number;
  name: string;
  slug: string;
  billable: boolean;
}

export interface SidebarCustomer {
  id: number;
  name: string;
  projects: SidebarProject[];
}

export interface SidebarCustomersResponse {
  data: SidebarCustomer[];
}

export async function fetchSidebarCustomers(): Promise<SidebarCustomer[]> {
  const response = await apiGet<SidebarCustomersResponse>('/sidebar/customers');
  return response.data;
}
